<template>
  <div>
    <account-bar></account-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import AccountBar from "@/components/navigation-bar/AccountBar.vue";
export default {
  components: { AccountBar },
};
</script>
